import Idle from './states/Idle';

export default class WallClicker
{
  constructor(camera_controller, walls_manager)
  {
    this.camera_controller = camera_controller;
    this.walls_manager = walls_manager;

    this.current_state = new Idle();
  }

  set_state(new_state)
  {
    this.current_state.on_exit(this);
    this.current_state = new_state;
    this.current_state.on_enter(this);
  }

  update()
  {
    this.current_state.update(this);
  }
}
